import { Grid } from '@mui/material';
import styles from './../../../../../assets/styles/componentStyles/widgetComponentStyles/extensionDrawer.module.scss'
import FAQSectionData from './faqSectionData';

const FAQSectionGlobal = (props: any) => {
    const { ref, thread, threadData, chatbotTheme } = props;

    return (
        <>
            <Grid container direction={"column"}>
                <Grid item className={styles.extension_drawer_popup_style}>
                    <FAQSectionData data={threadData} chatbotTheme={chatbotTheme} />
                </Grid>
            </Grid>
        </>

    )
}

export default FAQSectionGlobal